"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfListProfileDto = instanceOfListProfileDto;
exports.ListProfileDtoFromJSON = ListProfileDtoFromJSON;
exports.ListProfileDtoFromJSONTyped = ListProfileDtoFromJSONTyped;
exports.ListProfileDtoToJSON = ListProfileDtoToJSON;
exports.ListProfileDtoToJSONTyped = ListProfileDtoToJSONTyped;
const ListProfileSpecialtyDto_1 = require("./ListProfileSpecialtyDto");
const State_1 = require("./State");
const Roles_1 = require("./Roles");
/**
 * Check if a given object implements the ListProfileDto interface.
 */
function instanceOfListProfileDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('homeState' in value) || value['homeState'] === undefined)
        return false;
    if (!('dateOfBirth' in value) || value['dateOfBirth'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('ncsbnId' in value) || value['ncsbnId'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('isBlocked' in value) || value['isBlocked'] === undefined)
        return false;
    if (!('avatar' in value) || value['avatar'] === undefined)
        return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined)
        return false;
    if (!('readyToWorkAt' in value) || value['readyToWorkAt'] === undefined)
        return false;
    if (!('firstReadyToWorkAt' in value) || value['firstReadyToWorkAt'] === undefined)
        return false;
    if (!('roles' in value) || value['roles'] === undefined)
        return false;
    if (!('specialties' in value) || value['specialties'] === undefined)
        return false;
    return true;
}
function ListProfileDtoFromJSON(json) {
    return ListProfileDtoFromJSONTyped(json, false);
}
function ListProfileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'homeState': (0, State_1.StateFromJSON)(json['homeState']),
        'dateOfBirth': (json['dateOfBirth'] == null ? null : new Date(json['dateOfBirth'])),
        'email': json['email'],
        'ncsbnId': json['ncsbnId'],
        'createdAt': (new Date(json['createdAt'])),
        'isBlocked': json['isBlocked'],
        'avatar': json['avatar'],
        'phoneNumber': json['phoneNumber'],
        'readyToWorkAt': (json['readyToWorkAt'] == null ? null : new Date(json['readyToWorkAt'])),
        'firstReadyToWorkAt': (json['firstReadyToWorkAt'] == null ? null : new Date(json['firstReadyToWorkAt'])),
        'roles': (json['roles'].map(Roles_1.RolesFromJSON)),
        'specialties': (json['specialties'].map(ListProfileSpecialtyDto_1.ListProfileSpecialtyDtoFromJSON)),
    };
}
function ListProfileDtoToJSON(json) {
    return ListProfileDtoToJSONTyped(json, false);
}
function ListProfileDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'homeState': (0, State_1.StateToJSON)(value['homeState']),
        'dateOfBirth': (value['dateOfBirth'] == null ? null : value['dateOfBirth'].toISOString().substring(0, 10)),
        'email': value['email'],
        'ncsbnId': value['ncsbnId'],
        'createdAt': ((value['createdAt']).toISOString().substring(0, 10)),
        'isBlocked': value['isBlocked'],
        'avatar': value['avatar'],
        'phoneNumber': value['phoneNumber'],
        'readyToWorkAt': (value['readyToWorkAt'] == null ? null : value['readyToWorkAt'].toISOString()),
        'firstReadyToWorkAt': (value['firstReadyToWorkAt'] == null ? null : value['firstReadyToWorkAt'].toISOString()),
        'roles': (value['roles'].map(Roles_1.RolesToJSON)),
        'specialties': (value['specialties'].map(ListProfileSpecialtyDto_1.ListProfileSpecialtyDtoToJSON)),
    };
}
//# sourceMappingURL=ListProfileDto.js.map